import cat1 from './Graphics/proj5/cat_gaming.png';
import cat2 from './Graphics/proj5/cat_gaming_better.png';
import dog1 from './Graphics/proj5/cool_dog.png';
import dog2 from './Graphics/proj5/cool_dog_better.png';
import berk1 from './Graphics/proj5/uc_berk.png';
import berk2 from './Graphics/proj5/uc_berk_better.png';

import camp from './Graphics/proj5/campanile.png';
import camp1 from './Graphics/proj5/campanile_250.png';
import camp2 from './Graphics/proj5/campanile_500.png';
import camp3 from './Graphics/proj5/campanile_750.png';

import gauss1 from './Graphics/proj5/gauss_250.png';
import gauss2 from './Graphics/proj5/gauss_500.png';
import gauss3 from './Graphics/proj5/gauss_750.png';

import noise1 from './Graphics/proj5/noise_250.png';
import noise2 from './Graphics/proj5/noise_500.png';
import noise3 from './Graphics/proj5/noise_750.png';

import oneStep1 from './Graphics/proj5/1s_250.png';
import oneStep2 from './Graphics/proj5/1s_500.png';
import oneStep3 from './Graphics/proj5/1s_750.png';

import it690 from './Graphics/proj5/it690.png';
import it540 from './Graphics/proj5/it540.png';
import it390 from './Graphics/proj5/it390.png';
import it240 from './Graphics/proj5/it240.png';
import it90 from './Graphics/proj5/it90.png';
import itFinal from './Graphics/proj5/itFinal.png';
import itBlur from './Graphics/proj5/itBlur.png';
import itOne from './Graphics/proj5/itOne.png';

import sample1 from './Graphics/proj5/sample1.png';
import sample2 from './Graphics/proj5/sample2.png';
import sample3 from './Graphics/proj5/sample3.png';
import sample4 from './Graphics/proj5/sample4.png';
import sample5 from './Graphics/proj5/sample5.png';

import sample11 from './Graphics/proj5/sample11.png';
import sample22 from './Graphics/proj5/sample22.png';
import sample33 from './Graphics/proj5/sample33.png';
import sample44 from './Graphics/proj5/sample44.png';
import sample55 from './Graphics/proj5/sample55.png';

import ball from './Graphics/proj5/ball.png';
import ball1 from './Graphics/proj5/ball1.png';
import ball2 from './Graphics/proj5/ball2.png';
import ball3 from './Graphics/proj5/ball3.png';
import ball4 from './Graphics/proj5/ball4.png';
import ball5 from './Graphics/proj5/ball5.png';
import ball6 from './Graphics/proj5/ball6.png';

import pen from './Graphics/proj5/pen.png';
import pen1 from './Graphics/proj5/pen1.png';
import pen2 from './Graphics/proj5/pen2.png';
import pen3 from './Graphics/proj5/pen3.png';
import pen4 from './Graphics/proj5/pen4.png';
import pen5 from './Graphics/proj5/pen5.png';
import pen6 from './Graphics/proj5/pen6.png';

import ca1 from './Graphics/proj5/ca1.png';
import ca2 from './Graphics/proj5/ca2.png';
import ca3 from './Graphics/proj5/ca3.png';
import ca4 from './Graphics/proj5/ca4.png';
import ca5 from './Graphics/proj5/ca5.png';
import ca6 from './Graphics/proj5/ca6.png';

import pine from './Graphics/proj5/pine.png';
import pine1 from './Graphics/proj5/pine1.png';
import pine2 from './Graphics/proj5/pine2.png';
import pine3 from './Graphics/proj5/pine3.png';
import pine4 from './Graphics/proj5/pine4.png';
import pine5 from './Graphics/proj5/pine5.png';
import pine6 from './Graphics/proj5/pine6.png';

import house from './Graphics/proj5/house.png';
import house1 from './Graphics/proj5/house1.png';
import house2 from './Graphics/proj5/house2.png';
import house3 from './Graphics/proj5/house3.png';
import house4 from './Graphics/proj5/house4.png';
import house5 from './Graphics/proj5/house5.png';
import house6 from './Graphics/proj5/house6.png';

import face from './Graphics/proj5/face.png';
import face1 from './Graphics/proj5/face1.png';
import face2 from './Graphics/proj5/face2.png';
import face3 from './Graphics/proj5/face3.png';
import face4 from './Graphics/proj5/face4.png';
import face5 from './Graphics/proj5/face5.png';
import face6 from './Graphics/proj5/face6.png';

import mask from './Graphics/proj5/mask.png';
import toReplace from './Graphics/proj5/toReplace.png';
import inpaint from './Graphics/proj5/inpaint.png';

import club from './Graphics/proj5/club.png';
import mask2 from './Graphics/proj5/mask2.png';
import toReplace2 from './Graphics/proj5/toFill2.png';
import inpaint2 from './Graphics/proj5/inpaint2.png';

import pizza from './Graphics/proj5/pizza.png';
import mask3 from './Graphics/proj5/mask3.png';
import toReplace3 from './Graphics/proj5/toFill3.png';
import inpaint3 from './Graphics/proj5/inpaint3.png';

import cap1 from './Graphics/proj5/cap1.png';
import cap2 from './Graphics/proj5/cap2.png';
import cap3 from './Graphics/proj5/cap3.png';
import cap4 from './Graphics/proj5/cap4.png';
import cap5 from './Graphics/proj5/cap5.png';
import cap6 from './Graphics/proj5/cap6.png';

import catg1 from './Graphics/proj5/cat1.png';
import catg2 from './Graphics/proj5/cat2.png';
import catg3 from './Graphics/proj5/cat3.png';
import catg4 from './Graphics/proj5/cat4.png';
import catg5 from './Graphics/proj5/cat5.png';
import catg6 from './Graphics/proj5/cat6.png';

import box1 from './Graphics/proj5/box1.png';
import box2 from './Graphics/proj5/box2.png';
import box3 from './Graphics/proj5/box3.png';
import box4 from './Graphics/proj5/box4.png';
import box5 from './Graphics/proj5/box5.png';
import box6 from './Graphics/proj5/box6.png';

import anagram1 from './Graphics/proj5/anagram1.png';
import anagram2 from './Graphics/proj5/anagram2.png';

import hybrid1 from './Graphics/proj5/hybrid1.png';
import hybrid2 from './Graphics/proj5/hybrid2.png';

import noiseProcess from './Graphics/proj5/noiseProg.png';

import epoch1 from './Graphics/proj5/epoch1.png';
import epoch5 from './Graphics/proj5/epoch5.png';
import epochCurve from './Graphics/proj5/epochCurve.png';

import oodTest from './Graphics/proj5/oodTest.png';

import denoiseE1 from './Graphics/proj5/denoiseE1.png';
import denoiseE2 from './Graphics/proj5/denoiseE2.png';
import denoiseTrain from './Graphics/proj5/denoiseTrain.png';

import improveTrain from './Graphics/proj5/improveTrain.png';

import epoch11 from './Graphics/proj5/epoch11.png';
import epoch55 from './Graphics/proj5/epoch55.png';
import epoch1010 from './Graphics/proj5/epoch1010.png';

import ccTrain from './Graphics/proj5/ccTrain.png';
import cc1 from './Graphics/proj5/cc1.png';
import cc5 from './Graphics/proj5/cc5.png';
import cc10 from './Graphics/proj5/cc10.png';

function CS180Proj5() {
    return (
        <div className="text-white flex flex-col items-start m-auto px-20 py-10 font-mono gap-4">
            <h1 className="text-4xl font-bold">Project 5: Fun With Diffusion Models!</h1>
            <h1 className="text-4xl font-bold w-full text-center">Part A: <span className="text-green-500">The Power of Diffusion Models</span></h1>
            <div>
                <h3 className="text-2xl font-bold">Part 0: Setup</h3>
                <p className="text-lg">
                    Following setting up my Hugging Face account I proceeded to use the DeepFloyd IF
                    diffusion model to generate the following images. I started with num_inference_steps at 
                    20, and then boosted it to 40. It can be easily noted that the quality of the generations
                    grew substantially when doubling the number of inference steps and helped the model better semantically 
                    interpret the prompt. For example, when generating the "cool dog", less inference steps led the model
                    to slightly misinterpret the prompt, placing the dog in snow (a "cool" environment). But increasing the 
                    inference steps helped it better understand what I meant by cool, giving the dog a pair of "cool" shades.
                    Similarly, the painting of UC Berkeley became less photo-realistic with more steps, better adhering to the prompt.
                    The cat prompt stayed roughly the same, but with more detail to the feline and game controller.
                    The seed that was used was <b>100</b>.
                </p>
                <br/>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={cat1} />
                            "a photo of a cat playing a video game" <br/>(20 steps)
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={berk1} />
                            "a painting of UC Berkeley" <br/>(20 steps)
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={dog1} />
                            "a photo of a cool looking dog" <br/>(20 steps)
                        </div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={cat2} />
                            "a photo of a cat playing a video game" <br/>(40 steps)
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={berk2} />
                            "a painting of UC Berkeley" <br/>(40 steps)
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={dog2} />
                            "a photo of a cool looking dog" <br/>(40 steps)
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div>
                <h3 className="text-2xl font-bold">Part 1.1: Implementing the Forwarding Process</h3>
                <p className="text-lg">
                    We will now get started with implementing the sampling loops. The first part is
                    implementing the <b>forward</b> function. The results of which are displayed below.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-72">
                        <img src={camp} />
                        Berkeley Campanile
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={camp1} />
                        Noisy Campanile at t=250
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={camp2} />
                        Noisy Campanile at t=500
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={camp3} />
                        Noisy Campanile at t=750
                    </div>
                </div>
                <br/>
            </div>
            <div>
                <h3 className="text-2xl font-bold">Part 1.2: Classical Denoising</h3>
                <p className="text-lg">
                    Now that we have the forward pass complete, we can get started denoising our images.
                    The first attempt is a regular <b>Gaussian blur filtering</b>. The following are the noisified 
                    campanile images being denoised by a Gaussian filter with a kernel size of 7, and a standard deviation 
                    of 4.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={camp1} />
                            Noisy Campanile at t=250
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={camp2} />
                            Noisy Campanile at t=500
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={camp3} />
                            Noisy Campanile at t=750
                        </div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={gauss1} />
                            Gaussian Blur Denoising at t=250
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={gauss2} />
                            Gaussian Blur Denoising at t=500
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={gauss3} />
                            Gaussian Blur Denoising at t=750
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.3: One-Step Denoising</h3>
                <p className="text-lg">
                    With that failing to provide any impressive results, let's try the pretrained diffusion model
                    using one-step denoising.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={noise1} />
                            Noisy Campanile at t=250
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={noise2} />
                            Noisy Campanile at t=500
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={noise3} />
                            Noisy Campanile at t=750
                        </div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-96">
                            <img src={oneStep1} />
                            One-Step Denoised Campanile at t=250
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={oneStep2} />
                            One-Step Denoised Campanile at t=500
                        </div>
                        <div className="flex flex-col gap-2 w-96">
                            <img src={oneStep3} />
                            One-Step Denoised Campanile at t=750
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.4: Iterative Denoising</h3>
                <p className="text-lg">
                    Now we want to iteratively perform the operation rather than just denoising in one full step.
                    To do this I defined the <b>strided_timesteps</b> list: a sequence of 0 to 990 with a stride of 30
                    that is used to approach the fully-noised version. Then, I completed the <b>iterative_denoise</b> function, and 
                    used it to gain the following results. (The blur was achieved with the same kernel size and sigma as in 1.2).
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={it90} />
                            Noisy Campanile at t=90
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={it240} />
                            Noisy Campanile at t=240
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={it390} />
                            Noisy Campanile at t=390
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={it540} />
                            Noisy Campanile at t=540
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={it690} />
                            Noisy Campanile at t=690
                        </div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={camp} />
                            Original
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={itFinal} />
                            Iteratively Denoised Campanile
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={itOne} />
                            One-Step Denoised Campanile
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={itBlur} />
                            Gaussian Blurred Campanile
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.5: Diffusion Model Sampling</h3>
                <p className="text-lg">
                    To further test the implementation we can now attempt to derive random images by passing
                    in random noise. Five sampled images are provided below.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample1} />
                        Sample 1
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample2} />
                        Sample 2
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample3} />
                        Sample 3
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample4} />
                        Sample 4
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample5} />
                        Sample 5
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.6: Classifier-Free Guidance (CFG)</h3>
                <p className="text-lg">
                    The previous photos were clearly not all that impressive, to improve the quality I upgraded
                    the function with <b>Classifier-Free Guidance</b> and generated the following set.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample11} />
                        Sample 1
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample22} />
                        Sample 2
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample33} />
                        Sample 3
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample44} />
                        Sample 4
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <img src={sample55} />
                        Sample 5
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.7: Image-to-image Translation</h3>
                <p className="text-lg">
                    Now, we will attempted the SDEdit algorithm, adding in noise to target image and 
                    denoising it to get a new, edited form. This is done at noise levels [1, 3, 5, 7, 10, 20],
                    and the results on a few images are shown below.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={camp} />
                            Original: Campanile
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ca6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                    <br/>
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball} />
                            Original: Golf Ball
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={ball6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                    <br/>
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen} />
                            Original: Pen on Desk
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pen6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.7.1: Editing Hand-Drawn and Web Images</h3>
                <p className="text-lg">
                    We can repeat this with hand-drawn images to see how we can get them onto the natural image manifold.
                    The first one was taken from the web, the other two were drawn by me.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine} />
                            Original: Pineapple
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={pine6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                    <br />
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house} />
                            Original: House
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={house6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                    <br />
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face} />
                            Original: Face
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face1} />
                            SDEdit with i_start=1
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face2} />
                            SDEdit with i_start=3
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face3} />
                            SDEdit with i_start=5
                        </div>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face4} />
                            SDEdit with i_start=7
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face5} />
                            SDEdit with i_start=10
                        </div>
                        <div className="flex flex-col gap-2 w-72">
                            <img src={face6} />
                            SDEdit with i_start=20
                        </div>
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.7.2: Inpainting</h3>
                <p className="text-lg">
                    Now let's see if we can properly estimate a subsection of a given picture. To do this,
                    I implemented the <b>inpainting</b> function, and derived the following results. I estimated the top of
                    the campanile, the end of a golf club, and provided a new logo for Blondie's Pizza's box. It seems as 
                    if the golf club was turned into a flower, with the shaft acting as the flower stem, and the border of the 
                    pizza box was interpreted as the border of a picture frame.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={camp} />
                        Campanile
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={mask} />
                        Mask
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={toReplace} />
                        Hole to File
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={inpaint} />
                        Campanile Inpainted
                    </div>
                </div>
                <br />
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={club} />
                        Golf Club
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={mask2} />
                        Mask
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={toReplace2} />
                        Hole to File
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={inpaint2} />
                        Golf Club Inpainted
                    </div>
                </div>
                <br />
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={pizza} />
                        Golf Club
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={mask3} />
                        Mask
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={toReplace3} />
                        Hole to File
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={inpaint3} />
                        Golf Club Inpainted
                    </div>
                </div>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.7.3: Text-Conditional Image-to-image Translation</h3>
                <p className="text-lg">
                    Now we will attempt to guide the projection with a text prompt. The prompt used 
                    was <b>"a photo of a serene capybara"</b>. The following is the resulting transition along the 
                    various noise levels. Notice how the capybara stands up and morphs into the Campanile.
                    <br/>
                    <br/>
                </p>
                <div className="flex flex-row justify-center">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={camp} />
                        Campanile
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap1} />
                        Serene Capybara at noise level 1
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap2} />
                        Serene Capybara at noise level 3
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap3} />
                        Serene Capybara at noise level 5
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap4} />
                        Serene Capybara at noise level 7
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap5} />
                        Serene Capybara at noise level 10
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={cap6} />
                        Serene Capybara at noise level 20
                    </div>
                </div>
                <br/>
                <br/>
                <p>
                    Following that I tried two different transformations. <b>"a photo of a cat playing a video game"</b> was 
                    used with the golf ball photo and <b></b> was used with the pizza box photo. The results are displayed below.
                </p>
                <div className="flex flex-row justify-center">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={ball} />
                        Golf Ball
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg1} />
                        Gaming Cat at noise level 1
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg2} />
                        Gaming Cat at noise level 3
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg3} />
                        Gaming Cat at noise level 5
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg4} />
                        Gaming Cat at noise level 7
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg5} />
                        Gaming Cat at noise level 10
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={catg6} />
                        Gaming Cat at noise level 20
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-center">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={pizza} />
                        Pizza Box
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box1} />
                        Sunset at noise level 1
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box2} />
                        Sunset at noise level 3
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box3} />
                        Sunset at noise level 5
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box4} />
                        Sunset at noise level 7
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box5} />
                        Sunset at noise level 10
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={box6} />
                        Sunset at noise level 20
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.8: Visual Anagrams</h3>
                <p>
                    With all of that established, we're onto visual anagrams! After properly implementing the
                    function <b>visual_anagrams</b>, I generated the following pairs.
                </p>
                <br/>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={anagram1} />
                        A painting of a sleeping cat.
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={anagram1} className="rotate-180" />
                        A painting of a sunset over a lake.
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-2 w-96">
                        <img src={anagram2} />
                        A sketch of an angry skull.
                    </div>
                    <div className="flex flex-col gap-2 w-96">
                        <img src={anagram2} className="rotate-180" />
                        A sketch of a woman in a dress.
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.9: Hybrid Images</h3>
                <p>
                    Now we can also make hybrid images! I implemented the
                    function <b>make_hybrids</b>, and generated the following set.
                </p>
                <br/>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-3 w-96">
                        <img src={hybrid1} className="blur-md" />
                        "A lithograph of the moon." - Visible from afar
                        <br /> (Blurred for effect)
                    </div>
                    <div className="flex flex-col gap-3 w-96">
                        <img src={hybrid1} />
                        "A lithograph of waterfalls." - Visible up close
                    </div>
                </div>
                <br/>
                <div className="flex flex-row justify-around">
                    <div className="flex flex-col gap-3 w-96">
                        <img src={hybrid2} className="blur-md"/>
                        "A photo of a vase of flowers." - Visible from afar
                        <br /> (Blurred for effect)
                    </div>
                    <div className="flex flex-col gap-3 w-96">
                        <img src={hybrid2} />
                        "A photo of an old man." - Visible up close
                    </div>
                </div>
                <br/>
            </div>
            <h1 className="text-4xl font-bold w-full text-center">Part B: <span className="text-green-500">Flow Matching From Scratch!</span></h1>
            <div>
                <h3 className="text-2xl font-bold">Part 1.1: Implementing the UNet</h3>
                <p className="text-lg">
                    The first part of Part B was implementing the denoiser as a UNet. The
                    implementation was subsequently used for the following parts. 
                </p>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.2: Using the UNet to Train a Denoiser</h3>
                <p className="text-lg">
                    With the UNet etablished, the next step was to work on adding in some noise. The following 
                    diagram outlines the different noising processes over the range [0.0, 0.2, 0.4, 0.6, 0.8, 1.0].
                </p>
                <br/>
                <div className="flex flex-row justify-center">
                    <img src={noiseProcess} />
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.2.1: Training</h3>
                <p className="text-lg">
                    Now, onto training! Below is the denoising effort of our model after the first and fifth epochs, along 
                    with a graph highlighting the loss every few iterations during the process.
                </p>
                <br/>
                <div className="flex flex-col gap-4 text-center items-center w-full">
                    <div className="flex flex-col justify-center w-96">
                        <img src={epoch1} />
                        Results on some test digits after 1 epoch of training
                    </div>
                    <div className="flex flex-col justify-center w-96">
                        <img src={epoch5} />
                        Results on some test digits after 5 epochs of training
                    </div>
                    <div className="flex flex-col justify-center w-96">
                        <img src={epochCurve} />
                        Training Loss per Num Iterations
                    </div>
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.2.2: Out-of-Distribution Testing</h3>
                <p className="text-lg">
                    Since the denoiser was trained with a noise level of 0.5, the next step is to see how 
                    the denoiser performs on different noise levels that it wasn't trained for, as shown below.
                </p>
                <div className="flex flex-row justify-center">
                    <img src={oodTest} className="w-6/12" />
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 1.2.3: Denoising Pure Noise</h3>
                <p className="text-lg">
                    We now have a denoiser primed and ready for application, the next test is to see if we can
                    get comprehensible results from pure, random noise. The results, displayed below, seem to follow 
                    the general pattern of most written numbers. It is rounded, it has what looks like a hole in two places,
                    and has less emphasis in areas that are not typically covered while writing a number. It occupies the full space 
                    where writing all numbers would overlap, with less color in the areas where there would be less writing, offering an
                    explanation for why the typical traits are present.
                </p>
                <br/>
                <div className="font-bold">
                    <div className="flex flex-col items-center w-full">
                        <img src={denoiseTrain} className="w-6/12" />
                        Training loss every few iterations during the training process denoising pure noise.
                    </div>
                    <br/>
                    <div className="flex flex-col items-center w-full">
                        <img src={denoiseE1} className="w-6/12" />
                        Sample results on pure noise after the 1st epoch.
                    </div>
                    <br/>
                    <div className="flex flex-col items-center w-full">
                        <img src={denoiseE2} className="w-6/12" />
                        Sample results on pure noise after the 5th epoch.
                    </div>
                    <br/>
                </div>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.1: Adding Time Conditioning to UNet</h3>
                <p className="text-lg">
                    With such established, we can improve our model by integrating flow matching into our 
                    implementation. After introducing a scalar t into the UNet model, we continue on with the 
                    project.
                </p>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.2: Training the UNet</h3>
                <p className="text-lg">
                    After modifying the training loop to accommodate our newest additions,
                    we ran trained the new model, obtaining the following loss curve.
                </p>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={improveTrain} />
                    Loss over Iterations in Flow Matching Training
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.3: Sampling from the UNet</h3>
                <p className="text-lg">
                    We can observe the improved results with pure, random noise by sampling after 1, 5, and 10 epochs.
                </p>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={epoch11} />
                    Sample results on pure noise after the 1st epoch.
                </div>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={epoch55} />
                    Sample results on pure noise after the 5th epoch.
                </div>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={epoch1010} />
                    Sample results on pure noise after the 10th epoch.
                </div>
                <br/>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.4: Adding Class-Conditioning to UNet</h3>
                <p className="text-lg">
                    Looking to improve the results again, I introduced class-conditioning to the model.
                </p>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.5: Training the UNet</h3>
                <p className="text-lg">
                    With class-conditioning added, we can now observe the training loss again.
                </p>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={ccTrain} />
                    Loss over Iterations in Class-Conditioning Training
                </div>
                <br/>
            </div>
            <div className="w-full">
                <h3 className="text-2xl font-bold">Part 2.6: Sampling from the UNet</h3>
                <p className="text-lg">
                    To improve simplicity I removed the learning rate scheduler. Accordingly, I compensated for the loss using a 
                    constant learning rate of 5e-3 (the geometric mean of learning rate decaying over 10 epochs). This 
                    essentially provided the essentially the same impact--maintaining performance--without the complexity of the scheduler. 
                    The improved results can be viewed below.
                </p>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={cc1} />
                    Sample results on pure noise after the 1st epoch.
                </div>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={cc5} />
                    Sample results on pure noise after the 5th epoch.
                </div>
                <br/>
                <div className="flex flex-col items-center font-bold">
                    <img src={cc10} />
                    Sample results on pure noise after the 10th epoch.
                </div>
                <br/>
            </div>
            This project has been difficult, but enlightening. I've enjoying toying with the diffusion models and gaining 
            a better understanding of a piece of technology that has growing relevance in my life. Building the UNet has also helped 
            my intuitive understanding of the technology, and I'm excited to apply it in future work!
        </div>
    )
}

export default CS180Proj5;